import React from "react";

export default function LogoIcon() {
  return (
    <a href="https://www.npmjs.com/package/react-utility-table">
      
      <img
        style={{ height: "4.2rem", width: "100%" }}
        src={process.env.PUBLIC_URL + "/ruttable.jpg"}
        alt="React Utility Table Logo"
      />
    </a>
  );
}
